<div class="modal-error-confirm">
    <ng-container *ngIf="!isCameraActive">
        <span class="title">{{'kyc.select_upload_file' | translate}}</span>
        <button class="button-upload" (click)="openCamera()">{{'kyc.take_photo' | translate}}</button>
        <button class="button-upload" (click)="openGallery()">{{'kyc.select_photo' | translate}}</button>
        <input type="file" #fileInput capture="environment" accept="image/*" hidden (change)="handleFile($event)" />
        <input type="file" #galleryInput accept="image/*" hidden (change)="handleFile($event)" />
        <button (click)="closeModal()" class="btn-cancel" style="font-weight: 700;">{{'kyc.close' | translate}}</button>
    </ng-container>

   <div class="camera-section" *ngIf="isCameraActive">
       <video #videoElement class="camera-preview" autoplay playsinline></video>
       <button class="button-upload" (click)="capturePhoto()">Chụp</button>
       <button class="button-upload" (click)="stopCamera()">Hủy</button>
   </div>
   <!-- <div class="camera-error" *ngIf="isCameraError">
       <span>Không thể truy cập webcam. Vui lòng kiểm tra quyền truy cập camera hoặc chọn ảnh từ thư viện.</span>
   </div> -->

   <canvas #canvasElement hidden></canvas>
</div>
